export default function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-array/src/ascending.js
// module id = CHz1
// module chunks = 0